export interface ApplicationConfig {
    PROFILE_LEADERBOARDS: string;
    OVERRIDE_JWT: boolean;
    MAX_CLIENT_INACTIVITY_TIME: number;
    JSNG_BLOCKLIST: string[];
    FTO_PACKAGE_IDS: string[];
    AUTH0_ENV: 'local' | 'ci' | 'qc' | 'prod';
}

export const localApplicationConfig: ApplicationConfig = {
	PROFILE_LEADERBOARDS:
        'xsd_winratio_daily,xsd_winratio_weekly,gc_winratio_monthly,gc_winratio_weekly,gc_winratio_daily',
	OVERRIDE_JWT: true,
	MAX_CLIENT_INACTIVITY_TIME: 3600000 /*60 minutes*/,
	JSNG_BLOCKLIST: [],
	FTO_PACKAGE_IDS: ['1603270433721'],
	AUTH0_ENV: 'local',
}

export const ciApplicationConfig: ApplicationConfig = {
	PROFILE_LEADERBOARDS: 'uspo_ci_full_sim1',
	OVERRIDE_JWT: false,
	MAX_CLIENT_INACTIVITY_TIME: 3600000 /*60 minutes*/,
	JSNG_BLOCKLIST: [],
	FTO_PACKAGE_IDS: ['1603270433721'],
	AUTH0_ENV: 'ci',
}

export const qcApplicationConfig: ApplicationConfig = {
	PROFILE_LEADERBOARDS:
        'uspo_qc_full_sim1_sc,uspo_qc_full_sim1_gc,staff_tournament_test_rin,hltest_ringleader,gc_winratio_monthly,gc_winratio_weekly,gc_winratio_daily,xsd_winamount_hourly,xsd_winamount_weeklt,TorunamentSpecificLeaderboard_xcc,xsd_winamount_daily',
	OVERRIDE_JWT: false,
	MAX_CLIENT_INACTIVITY_TIME: 1800000 /*30 minutes*/,
	JSNG_BLOCKLIST: ['PurrStacker'],
	FTO_PACKAGE_IDS: ['1782197656933'],
	AUTH0_ENV: 'qc',
}

export const prodApplicationConfig: ApplicationConfig = {
	PROFILE_LEADERBOARDS: 'goldrush_daily,goldrush_weekly,goldrush_monthly',
	OVERRIDE_JWT: false,
	MAX_CLIENT_INACTIVITY_TIME: 1800000 /*30 minutes*/,
	JSNG_BLOCKLIST: ['PurrStacker'],
	FTO_PACKAGE_IDS: ['1782196760028'],
	AUTH0_ENV: 'prod',
}
